import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked", "value"]

import { computed } from 'vue'

export type VCheckboxColor =
    | 'primary'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
export interface VCheckboxEmits {
  (e: 'update:modelValue', value: (string | number)[]): void
}
export interface VCheckboxProps {
  value?: string | number
  label?: string
  color?: VCheckboxColor
  modelValue?: (string | number)[]
  circle?: boolean
  solid?: boolean
  paddingless?: boolean
}

const name='VCheckbox'

export default /*@__PURE__*/_defineComponent({
  __name: 'VCheckbox',
  props: {
    value: { default: undefined },
    label: { default: undefined },
    color: { default: undefined },
    modelValue: { default: () => [] },
    circle: { type: Boolean, default: false },
    solid: { type: Boolean, default: false },
    paddingless: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props

const checked = computed(() => props.modelValue.includes(props.value))
function change() {
  const values = [...props.modelValue]

  if (checked.value) {
    values.splice(values.indexOf(props.value), 1)
  } else {
    values.push(props.value)
  }
  emit('update:modelValue', values)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["checkbox", [
      props.solid ? 'is-solid' : 'is-outlined',
      props.circle && 'is-circle',
      props.color && `is-${props.color}`,
      props.paddingless && 'is-paddingless',
    ]])
  }, [
    _createElementVNode("input", _mergeProps({
      type: "checkbox",
      checked: checked.value,
      value: props.value
    }, _ctx.$attrs, { onChange: change }), null, 16, _hoisted_1),
    _cache[0] || (_cache[0] = _createElementVNode("span", null, null, -1)),
    _createTextVNode(" " + _toDisplayString(props.label || props.value), 1)
  ], 2))
}
}

})